import { createSlice } from "@reduxjs/toolkit";
import { fetchStudentPublicProfile } from "./operation.js";

const initialState = {
  student: null,
  loading: false,
  error: null,
};

const studentPublicSlice = createSlice({
  name: "studentPublic",
  initialState,
  reducers: {
    resetStudentPublic(state) {
      state.student = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStudentPublicProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudentPublicProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.student = action.payload;
      })
      .addCase(fetchStudentPublicProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetStudentPublic } = studentPublicSlice.actions;
export default studentPublicSlice.reducer;
